import gsap from 'gsap';

export default class Loader {
  constructor() {
    this.loader = document.querySelector('.loader-container')
    this.progressBar = document.querySelector('.progress-bar')

    if (!this.loader) return;

    this.init();
  }

  init() {
    this.trackProgress();
  }


  updateProgress(percent) {
    gsap.to(this.progressBar, {
      width: `${percent}%`,
      duration: 0.3,
      ease: 'power1.inOut'
    });

    if (percent >= 100) {
      setTimeout(() => {
        this.progressBar.classList.add('complete');
      }, 1000);

      setTimeout(() => {
        this.revealSite();

      }, 1500);
    }
  }

  trackProgress() {
    let progress = 0;
    const interval = setInterval(() => {
      progress += Math.random() * 35; // Simulate progress
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      this.updateProgress(progress);
    }, 200);
  }

  revealSite() {
    // Étape 1 : Animer le contenu du splash (logo et barre de progression)
    gsap.to(this.loader.querySelector('.loader-content'), {
      opacity: 0,
      duration: 0.3,
      ease: 'power2.out',
      onComplete: () => {
        // Étape 2 : Ajouter la classe pour l'animation du volet
        this.loader.classList.add('reveal-animation');

        // Étape 3 : Après que le volet ait couvert l'écran, masquer le splash screen
        this.loader.classList.add('hidden');
        document.body.classList.remove('loading');

        // Étape 4 : Animer les éléments de la page une fois le splash screen disparu
        this.animatePageElements();
      }
    });
  }

  animatePageElements() {
    // Animations des éléments de la page après la disparition du splash screen
    const heroTitle = document.querySelector('.s-hero .c-image img');
    const heroContent = document.querySelector('.s-hero .container > .c-title');

    if (heroTitle) {
      gsap.from(heroTitle, {
        y: 80,
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out'
      });
    }

    if (heroContent) {
      gsap.from(heroContent, {
        y: 70,
        opacity: 0,
        duration: 1,
        delay: 0.2,
        ease: 'power2.out'
      });
    }
  }

}
